import React, { Component } from "react";
import { FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import config from "../config";
import "./NewBodySign.css";
import { API } from "aws-amplify";
import { s3Upload } from "../libs/awsLib";
//import ButtonToolbar from "./BodySigns";

export default class NewBodySign extends Component {
  constructor(props) {
    super(props);

    this.file = null;

    this.state = {
      isLoading: null,
      content: "",
      intent: ""
    };
  }

  validateForm() {
    return (this.state.content.length > 0 && this.getValidationState() === 'success');
  }

  getValidationState() {
    const colons = this.state.content.trim().split(":");
    if (colons.length > 4) return 'success';
    else if (colons.length > 0) return 'error';
    return null;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleFileChange = event => {
    this.file = event.target.files[0];
  }

  handleCancel = async event => {
    event.preventDefault();

    this.setState({ isLoading: true });
    this.props.history.push("/");
  }

  handleSubmit = async event => {
    event.preventDefault();

    if (this.file && this.file.size > config.MAX_ATTACHMENT_SIZE) {
      alert(`Please pick a file smaller than ${config.MAX_ATTACHMENT_SIZE/1000000} MB.`);
      return;
    }

    this.setState({ isLoading: true });
    console.log(this.state.content.trim().split(":")[0]);
    try {

      const attachment = this.file
        ? await s3Upload(this.file)
        : null;

      await this.createBodySign({
        content: this.state.content
      });
      this.props.history.push("/");
    } catch (e) {
      alert(e);
      this.setState({ isLoading: false });
    }
  }

  createBodySign(bodysign) {
    return API.post("bodysigns", "/notebook", {
      body: bodysign
    });
  }

  render() {
    return (
      <div className="NewBodySign">
        <form onSubmit={this.handleSubmit}>
          <p>Note: Due to popular demand, this form is being re-worked!<br/>
            For now, please enter the raw data in following format:<br/><br/>
            => <b>[Symptom:Vital Type:State:Measurement:Description]</b><br/><br/>
                List of Symptoms: [Bruising, Discharge, Dryness, Eating, Exercising, Loss, Medicines, Numbness, Pain, Rash, Sleep, Stuffiness, Swelling, Tingling, Vitals]<br/><br/>
            Examples:<br/>
            1. Bleeding:Gum:thumbs-down:60 mins:Sustained, Intensified<br/>
            2. Exercise:Walking:thumbs-up:35 mins:Strenuous climbs
          </p>
          <p>&nbsp;</p>
          <FormGroup 
            controlId="content" 
            validationState={this.getValidationState()}
          >
            <FormControl
              onChange={this.handleChange}
              value={this.state.content}
              type="text"
            />
            <FormControl.Feedback />
          </FormGroup>
          <FormGroup controlId="file">
            <ControlLabel>Attach an image of the symptom (if applicable)</ControlLabel>
            <FormControl onChange={this.handleFileChange} type="file" />
          </FormGroup>
          <LoaderButton
              bsStyle="info"
              type="submit"
              isLoading={this.state.isLoading}
              onClick={this.handleCancel}
              text="Cancel"
              loadingText="Canceling…"
          />&nbsp;
          <LoaderButton
            bsStyle="primary"
            disabled={!this.validateForm()}
            type="submit"
            isLoading={this.state.isLoading}
            text="Create"
            loadingText="Creating…"
          />
        </form>
      </div>
    );
  }

/*
  render() {
    return (
        <div className="BodySigns">
          {this.state.bodysign &&
          <form onSubmit={this.handleSubmit}>
            <FormGroup controlId="content">
              <FormControl
                  onChange={this.handleChange}
                  value={this.state.content}
                  componentClass="textarea"
              />
            </FormGroup>
            {this.state.bodysign.attachment &&
            <FormGroup>
              <ControlLabel>Attachment</ControlLabel>
              <FormControl.Static>
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={this.state.attachmentURL}
                >
                  {this.formatFilename(this.state.bodysign.attachment)}
                </a>
              </FormControl.Static>
            </FormGroup>}
            <FormGroup controlId="file">
              {!this.state.bodysign.attachment &&
              <ControlLabel>Attachment</ControlLabel>}
              <FormControl onChange={this.handleFileChange} type="file" />
            </FormGroup>
            <ButtonToolbar>
              <LoaderButton
                  bsStyle="info"
                  disabled={!this.validateForm()}
                  type="submit"
                  isLoading={this.state.isLoading}
                  onClick={this.handleCancel}
                  text="Cancel"
                  loadingText="Canceling…"
              />
              <LoaderButton
                  bsStyle="primary"
                  disabled={!this.validateForm()}
                  type="submit"
                  isLoading={this.state.isLoading}
                  text="Save"
                  loadingText="Saving…"
              />
            </ButtonToolbar>
          </form>}
        </div>
    );
  }
*/

}
